import React from 'react';

const stepsData = [
  {
    step: 'Step 01',
    title: 'Idea & Planning',
    description:
      'We first understand your business, specific aims, target market, and competitors. Our e-commerce website design team collaborates with you to map out a complete plan that aligns with your vision. Our team analyzes your business objectives and defines measurable KPIs for the best working. We also research your target audience behavior and competitor strategies to recognize market opportunities and potential growth areas.',
    icon: (
      <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#c40a0a" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M15 14c.2-1 .7-1.7 1.5-2.5 1-1 1.5-2 1.5-3.5A6 6 0 0 0 6 8c0 1 .2 2.2 1.5 3.5.7.7 1.3 1.5 1.5 2.5" />
        <path d="M9 18h6" />
        <path d="M10 22h4" />
      </svg>
    )
  },
  {
    step: 'Step 02',
    title: 'Architecture & User Experience Design',
    description:
      'Our design architects build wireframes and site structures to guide customers from browsing to buying. We prioritize conversion optimized layouts that turn visitors into customers. Our sitemaps and user flow diagrams simplify complex content structures to make navigation easy for users and search engines. Our e-commerce web development agency selects the best technology stack and platform architecture to maintain the scalability and performance of the site.',
    icon: (
      <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#c40a0a" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
        <line x1="3" y1="9" x2="21" y2="9" />
        <line x1="9" y1="21" x2="9" y2="9" />
      </svg>
    )
  },
  {
    step: 'Step 03',
    title: 'Design & Development',
    description:
      'Our professional designers and developers build your store with attractive and strong functionality. We make custom brand aligned visual designs that are distinct and functional. Our developers provide clean code that is optimized for speed and performance. Our eCommerce store development services include important features, payment gateways, and third-party tools to make sure your store operates without any flaws. Our team follows a mobile first approach and maintains cross device compatibility in the sites to provide a professional online store that builds trust, drives conversions, and positions your brand as an industry leader.',
    icon: (
      <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#c40a0a" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="16 18 22 12 16 6" />
        <polyline points="8 6 2 12 8 18" />
        <path d="M12 2v20" />
      </svg>
    )
  },
  {
    step: 'Step 04',
    title: 'QA & Successful Launch',
    description:
      'Before your store goes live, our quality assurance team conducts complete testing to maintain flawless performance. We perform comprehensive testing across all devices, browsers, and user scenarios while we conduct security audits and performance optimization checks. Our e-commerce website development company in Pakistan executes a smooth launch with minimal downtime and maximum impact, then provides continuous monitoring, maintenance, and strategic improvements for your business.',
    icon: (
      <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#c40a0a" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09z" />
        <path d="m12 15-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 0 1-4 2z" />
        <path d="M9 12H4s.55-3.03 2-4c1.62-1.08 5 0 5 0" />
        <path d="M12 15v5s3.03-.55 4-2c1.08-1.62 0-5 0-5" />
      </svg>
    )
  }
];

function EcommerceProcessSteps() {
  return (
    <section className="ecom-steps-section">
      <div className="container">
        {/* Section Header */}
        <div className="ecom-steps-header">
          <div className="ecom-steps-badge-row">
            <span className="ecom-steps-badge">Proven Execution Framework</span>
            <div className="ecom-steps-badge-line"></div>
          </div>

          <h2 className="ecom-steps-title">
            Your E-commerce Success, <span className="text-red">Our Expertise</span>
          </h2>

          <p className="ecom-steps-subtitle">
            A structured, conversion-driven development lifecycle engineered to transform your business vision into a high-growth digital store.
          </p>
        </div>

        {/* 4-Step Cards Grid */}
        <div className="ecom-steps-grid">
          {stepsData.map((item, index) => (
            <div key={index} className="ecom-step-card">
              {/* Card Top: Step Pill & Red Icon */}
              <div className="ecom-step-card-top">
                <span className="ecom-step-pill">{item.step}</span>
                <div className="ecom-step-icon-wrapper">
                  {item.icon}
                </div>
              </div>

              {/* Step Title with red accent line */}
              <div className="ecom-step-title-wrap">
                <h3 className="ecom-step-card-title">{item.title}</h3>
                <div className="ecom-step-title-line"></div>
              </div>

              {/* Step Description */}
              <p className="ecom-step-card-desc">{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default EcommerceProcessSteps;
